import i18next from 'i18next';

import { createSingleton } from '@luna/utils';

export const overrideSuffixSingleton = createSingleton<string | undefined>();

export function resolveKey(key: string, overrideSuffix?: string): string {
    if (!key || !overrideSuffix) {
        return key;
    }

    const keyWithOverrideSuffix = key + overrideSuffix;

    if (i18next.exists(keyWithOverrideSuffix)) {
        return keyWithOverrideSuffix;
    }

    return key;
}
